// No Crashlytics SDK on web — provide a no-op implementation so shared
// code can call crashlytics() on every platform without guards.
export default function crashlytics() {
  return {
    log: (_message: string) => {},
    recordError: (_error: Error, _jsErrorName?: string) => {},
    setUserId: async (_userId: string) => {},
    setAttribute: async (_name: string, _value: string) => {},
    setAttributes: async (_attributes: Record<string, string>) => {},
    setCrashlyticsCollectionEnabled: async (_enabled: boolean) => {},
    crash: () => {},
  };
}
